// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_02712f2b3b--checkbox--E83MD","box":"_02712f2b3b--box--TSmoe","invalid":"_02712f2b3b--invalid--duKFV","disabled":"_02712f2b3b--disabled--WW5p9"};